import './BenefitsNewServicing.scss';
import { Grid, Typography } from '@mui/material';

const BenefitsNewServicing = ({ data }) => {
  const imageUrls = [
    '/images/benefits/newservicing/item1.png',
    '/images/benefits/newservicing/item2.png'
  ];
  
  if(!data){
    return null;
  }

  return (
    <div
      aria-labelledby="benefits-new-servicing-title-id"
      className="benefits-new-servicing"
    >
      <Typography
        className="title"
        id="benefits-new-servicing-title-id"
        variant="h2"
      >
        {data.title}
      </Typography>
      {data.sections.map((section, index) => (
        <Grid
          key={`section-${section.id}`}
          container
          className="benefits-new-servicing-item"
        >
          <Grid item className="img">
            <img src={imageUrls[index]} alt="" />
          </Grid>
          <Grid item className="content">
            <Typography className="item-title">{section.title}</Typography>
            {section?.list.map((listItem) => (
              <div
                key={`ben1-${listItem.id}`}
                dangerouslySetInnerHTML={{ __html: listItem.item }}
              ></div>
            ))}
          </Grid>
        </Grid>
      ))}
    </div>
  );
};

export default BenefitsNewServicing;
